import * as React from "react";
import ReactHtmlParser from "react-html-parser";

import { TagTitle } from "../../../types/thecookies";
import DoNotMountComponent from "../../DoNotMountComponent/DoNotMountComponent";

export const createTitle = (title: string, type?: TagTitle, props?: object) => {
  if (!title || title === "null" || title === "undefined" || typeof title !== "string")
    return <DoNotMountComponent sms={"falta title"} log={title} />;
  return React.createElement(type || "p", props ? { ...props } : { className: "a-title" }, getHtmlFromString(title));
};

function getHtmlFromString(str: string) {
  const partsString = str.split("\\n");
  return partsString.map((item, index) => {
    const replacedItem = item.replace(/\*([^*]+)\*/g, "<span>$1</span>");
    return (
      <React.Fragment key={index}>
        {ReactHtmlParser(replacedItem)}
        {index <= partsString.length - 2 && <br />}
      </React.Fragment>
    );
  });
}
